var _defs, _text, _text2, _text3, _text4, _text5, _text6, _text7, _g, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _g2, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37, _text38, _text39, _g3, _text40, _text41, _text42, _text43, _text44, _text45, _text46, _text47, _text48, _text49, _text50, _text51, _text52, _text53, _text54, _text55, _g4, _text56, _text57, _text58, _text59, _text60, _text61, _text62, _text63;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_228",
    "data-name": "Grupo 228",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 359.524,
    height: 359.946,
    viewBox: "0 0 359.524 359.946",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_557",
    "data-name": "Ret\\xE2ngulo 557",
    width: 359.524,
    height: 359.946
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "\\xC9",
    transform: "translate(80.237 51.421) rotate(-35.632)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xC9"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": " ",
    transform: "translate(90.348 44.283) rotate(-32.471)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "I",
    transform: "matrix(0.862, -0.507, 0.507, 0.862, 95.121, 41.244)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "S",
    transform: "translate(99.882 38.319) rotate(-27.208)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "S-2",
    "data-name": "S",
    transform: "matrix(0.923, -0.385, 0.385, 0.923, 111.279, 32.451)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "O",
    transform: "matrix(0.952, -0.307, 0.307, 0.952, 123.075, 27.484)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": " ",
    transform: "translate(136.686 23.233) rotate(-14.339)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_220",
    "data-name": "Grupo 220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_219",
    "data-name": "Grupo 219",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Q",
    transform: "translate(142.063 21.716) rotate(-10.812)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q")), /*#__PURE__*/React.createElement("text", {
    id: "U",
    transform: "translate(156.036 19.051) rotate(-5.889)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U")), /*#__PURE__*/React.createElement("text", {
    id: "E",
    transform: "translate(169.617 17.672) rotate(-1.349)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": " ",
    transform: "translate(182.014 17.468) rotate(1.769)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "I-2",
    "data-name": "I",
    transform: "translate(187.629 17.64) rotate(3.729)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "M",
    transform: "translate(193.204 17.763) rotate(7.932)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "P",
    transform: "translate(211.276 20.408) rotate(13.389)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    id: "O-2",
    "data-name": "O",
    transform: "translate(223.553 23.287) rotate(18.164)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    id: "R",
    transform: "translate(237.041 27.712) rotate(23.135)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    id: "T",
    transform: "translate(249.577 33.115) rotate(27.458)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    id: "A",
    transform: "matrix(0.857, 0.516, -0.516, 0.857, 258.102, 37.47)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    id: "_.",
    "data-name": ".",
    transform: "translate(268.7 43.966) rotate(34.278)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "."))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": " ",
    transform: "matrix(0.806, 0.591, -0.591, 0.806, 273.339, 47.126)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    id: "O-3",
    "data-name": "O",
    transform: "translate(277.927 50.319) rotate(39.746)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": " ",
    transform: "translate(288.816 59.541) rotate(43.228)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    id: "M-2",
    "data-name": "M",
    transform: "translate(293.017 63.163) rotate(47.413)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    id: "O-4",
    "data-name": "O",
    transform: "matrix(0.6, 0.8, -0.8, 0.6, 305.322, 76.686)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    id: "V",
    transform: "matrix(0.536, 0.844, -0.844, 0.536, 313.561, 87.689)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    id: "I-3",
    "data-name": "I",
    transform: "matrix(0.489, 0.872, -0.872, 0.489, 320.001, 97.988)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    id: "M-3",
    "data-name": "M",
    transform: "matrix(0.424, 0.906, -0.906, 0.424, 322.923, 102.697)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    id: "E-2",
    "data-name": "E",
    transform: "translate(330.557 119.328) rotate(70.364)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    id: "N",
    transform: "matrix(0.256, 0.967, -0.967, 0.256, 334.759, 130.922)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_222",
    "data-name": "Grupo 222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_221",
    "data-name": "Grupo 221",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "T-2",
    "data-name": "T",
    transform: "matrix(0.178, 0.984, -0.984, 0.178, 338.477, 145.275)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "O-5",
    "data-name": "O",
    transform: "translate(340.388 155.341) rotate(83.964)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "_.-2",
    "data-name": ".",
    transform: "translate(341.763 169.536) rotate(87.438)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, ".")), /*#__PURE__*/React.createElement("text", {
    id: "_6",
    "data-name": " ",
    transform: "translate(341.999 175.166) rotate(89.071)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "A-2",
    "data-name": "A",
    transform: "translate(342.164 180.74) rotate(92.46)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    id: "_7",
    "data-name": " ",
    transform: "matrix(-0.097, 0.995, -0.995, -0.097, 341.559, 192.845)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "A-3",
    "data-name": "A",
    transform: "translate(341.112 198.402) rotate(98.676)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    id: "D",
    transform: "translate(339.354 210.331) rotate(103.401)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D"))))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    id: "A-4",
    "data-name": "A",
    transform: "matrix(-0.309, 0.951, -0.951, -0.309, 336.051, 224.079)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    id: "P-2",
    "data-name": "P",
    transform: "matrix(-0.38, 0.925, -0.925, -0.38, 332.345, 235.549)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    id: "T-3",
    "data-name": "T",
    transform: "translate(327.523 247.21) rotate(116.533)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    id: "A-5",
    "data-name": "A",
    transform: "translate(323.301 255.814) rotate(120.127)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    id: "\\xC7",
    transform: "matrix(-0.567, 0.824, -0.824, -0.567, 317.279, 266.242)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xC7"))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    id: "\\xC3",
    transform: "matrix(-0.629, 0.778, -0.778, -0.629, 309.863, 276.992)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xC3"))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    id: "O-6",
    "data-name": "O",
    transform: "matrix(-0.689, 0.724, -0.724, -0.689, 302.311, 286.408)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    id: "_.-3",
    "data-name": ".",
    transform: "matrix(-0.732, 0.681, -0.681, -0.732, 292.385, 296.653)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "."))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": " ",
    transform: "translate(288.266 300.488) rotate(139.036)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    id: "A-6",
    "data-name": "A",
    transform: "translate(284.118 304.21) rotate(142.138)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    id: "_9",
    "data-name": " ",
    transform: "matrix(-0.822, 0.57, -0.57, -0.822, 274.513, 311.573)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    id: "E-3",
    "data-name": "E",
    transform: "matrix(-0.852, 0.524, -0.524, -0.852, 269.978, 314.837)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    id: "V-2",
    "data-name": "V",
    transform: "translate(259.451 321.311) rotate(152.737)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V"))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    id: "O-7",
    "data-name": "O",
    transform: "translate(249.18 326.679) rotate(157.227)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    id: "L",
    transform: "translate(236.034 332.139) rotate(161.714)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L"))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    id: "U-2",
    "data-name": "U",
    transform: "matrix(-0.97, 0.242, -0.242, -0.97, 225.911, 335.555)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_224",
    "data-name": "Grupo 224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_223",
    "data-name": "Grupo 223",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\xC7-2",
    "data-name": "\\xC7",
    transform: "translate(212.672 338.856) rotate(170.716)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xC7")), /*#__PURE__*/React.createElement("text", {
    id: "\\xC3-2",
    "data-name": "\\xC3",
    transform: "matrix(-0.996, 0.085, -0.085, -0.996, 199.792, 340.946)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xC3")), /*#__PURE__*/React.createElement("text", {
    id: "O-8",
    "data-name": "O",
    transform: "translate(187.807 341.936) rotate(179.071)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "_.-4",
    "data-name": ".",
    transform: "translate(173.49 341.961) rotate(-176.826)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, ".")), /*#__PURE__*/React.createElement("text", {
    id: "\\xC9-2",
    "data-name": "\\xC9",
    transform: "matrix(-0.994, -0.11, 0.11, -0.994, 167.925, 341.749)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xC9")), /*#__PURE__*/React.createElement("text", {
    id: "_10",
    "data-name": " ",
    transform: "translate(155.608 340.295) rotate(-170.502)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "I-4",
    "data-name": "I",
    transform: "translate(150.075 339.371) rotate(-168.514)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    id: "S-3",
    "data-name": "S",
    transform: "matrix(-0.967, -0.255, 0.255, -0.967, 144.585, 338.366)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    id: "S-4",
    "data-name": "S",
    transform: "translate(132.176 335.102) rotate(-160.674)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    id: "O-9",
    "data-name": "O",
    transform: "translate(120.059 330.891) rotate(-155.867)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    id: "_11",
    "data-name": " ",
    transform: "translate(107.103 324.946) rotate(-152.357)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    id: "Q-2",
    "data-name": "Q",
    transform: "translate(102.092 322.476) rotate(-148.846)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q"))), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    id: "U-3",
    "data-name": "U",
    transform: "translate(89.927 315.118) rotate(-143.938)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U"))), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    id: "E-4",
    "data-name": "E",
    transform: "translate(78.908 307.072) rotate(-139.377)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    id: "_12",
    "data-name": " ",
    transform: "translate(69.549 298.921) rotate(-136.217)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    id: "I-5",
    "data-name": "I",
    transform: "translate(65.486 295.029) rotate(-134.242)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    id: "M-4",
    "data-name": "M",
    transform: "matrix(-0.644, -0.765, 0.765, -0.644, 61.445, 291.223)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"))), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    id: "P-3",
    "data-name": "P",
    transform: "matrix(-0.568, -0.823, 0.823, -0.568, 49.77, 277.143)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    id: "O-10",
    "data-name": "O",
    transform: "matrix(-0.499, -0.867, 0.867, -0.499, 42.587, 266.82)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    id: "R-2",
    "data-name": "R",
    transform: "translate(35.498 254.496) rotate(-114.951)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    id: "T-4",
    "data-name": "T",
    transform: "translate(29.774 242.091) rotate(-110.617)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    id: "A-7",
    "data-name": "A",
    transform: "translate(26.343 233.158) rotate(-107.011)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    id: "_.-5",
    "data-name": ".",
    transform: "translate(22.807 221.269) rotate(-103.759)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "."))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_226",
    "data-name": "Grupo 226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_225",
    "data-name": "Grupo 225",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_13",
    "data-name": " ",
    transform: "translate(21.466 215.792) rotate(-101.756)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "O-11",
    "data-name": "O",
    transform: "matrix(-0.143, -0.99, 0.99, -0.143, 20.192, 210.349)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "_14",
    "data-name": " ",
    transform: "translate(18.276 196.224) rotate(-94.747)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "M-5",
    "data-name": "M",
    transform: "translate(17.636 190.697) rotate(-90.929)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "O-12",
    "data-name": "O",
    transform: "translate(17.481 172.433) rotate(-84.936)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "V-3",
    "data-name": "V",
    transform: "matrix(0.166, -0.986, 0.986, 0.166, 18.711, 158.742)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V")), /*#__PURE__*/React.createElement("text", {
    id: "I-6",
    "data-name": "I",
    transform: "translate(20.804 146.793) rotate(-77.326)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))))), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    id: "M-6",
    "data-name": "M",
    transform: "matrix(0.291, -0.957, 0.957, 0.291, 21.788, 141.313)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"))), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    id: "E-5",
    "data-name": "E",
    transform: "matrix(0.38, -0.925, 0.925, 0.38, 27.233, 123.865)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    id: "N-2",
    "data-name": "N",
    transform: "translate(31.875 112.423) rotate(-62.824)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"))), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    id: "T-5",
    "data-name": "T",
    transform: "matrix(0.526, -0.851, 0.851, 0.526, 38.699, 99.284)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    id: "O-13",
    "data-name": "O",
    transform: "translate(44.012 90.515) rotate(-54.089)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    id: "_.-6",
    "data-name": ".",
    transform: "translate(52.493 79.024) rotate(-50.596)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "."))), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    id: "_15",
    "data-name": " ",
    transform: "matrix(0.661, -0.75, 0.75, 0.661, 56.047, 74.694)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    id: "_16",
    "data-name": " ",
    transform: "translate(59.787 70.447) rotate(-46.644)",
    fontSize: 21,
    fontFamily: "FranklinGothic-Book, Franklin Gothic Book"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundText);
export default __webpack_public_path__ + "static/media/round-text.1f3aad003730ed04af8a84dcb9190524.svg";
export { ForwardRef as ReactComponent };